Vue.component('goal-breakdown', {
  props: ['goal', 'breakdown'],

  computed: {
    isRatingOk() {
      return this.goal.current_stats.average_rating > this.goal.details.review_average
    },
    goalDiff() {
      return this.goal.current_stats.average_rating_at_source_scale - this.goal.details.review_average_at_source_scale
    },
    goalDiffText() {

      if (! this.hasGoalStarted) return ''

      let text = ''

      
      if (this.isRatingOk) {
        text += '&uarr;'
      } else {
        text += '&darr;'
      }

      text += (this.goalDiff).toFixed(2)

      return text
    },
    goalDiffClass() {
      if (this.goalDiff == 0) {
        return ''
      } else if (this.goalDiff > 0) {
        return 'text-success'
      } else {
        return 'text-danger'
      }
    },
    hasGoalStarted() {
      return this.goal.current_stats.no_of_reviews > 0
    }
  }
})